import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';

import { ApiStatus } from '../types';
import { getTimeline } from './actions';
import { ErrorMessageFromApi } from 'src/constants';

type initialStateT = {
  data?: any[];
  loadingStatus: ApiStatus;
};
const initialState: initialStateT = {
  loadingStatus: 'IDLE',
};

const timelineSlice = createSlice({
  name: 'timelineSlice',
  initialState,
  reducers: {
    toggleTrackOpen: (
      state,
      action: PayloadAction<{ trackId: string | number }>
    ) => {
      const { data } = state ?? {};
      const { trackId } = action.payload ?? {};
      const updatedTracks = (data ?? [])?.map((t) => {
        if (t?.id === trackId) {
          return {
            ...t,
            isOpen: !t.isOpen,
          };
        }
        return t;
      });
      state.data = updatedTracks;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getTimeline.pending, (state) => {
        state.loadingStatus = 'PENDING';
      })
      .addCase(getTimeline.fulfilled, (state, action) => {
        state.loadingStatus = 'SUCCESS';

        state.data = action.payload;
      })
      .addCase(getTimeline.rejected, (state, action) => {
        state.loadingStatus = 'ERROR';
        state.data = [];
        toast.error(ErrorMessageFromApi, { duration: 2000 });
      });
  },
});
export const { toggleTrackOpen } = timelineSlice.actions;
export default timelineSlice.reducer;
